export default {
  drawer: null,
  color: 'pipefishGreen',
  // image: 'https://demos.creative-tim.com/vue-material-dashboard/img/sidebar-2.32103624.jpg'
  image: process.env.VUE_APP_IMAGE,//'/img/scales1.png',
  userProfile: {}
}
